<template>
    <div class="checkCondition" style="display: block">
        <div class="checkCondition_header">
            <div class="checkCondition_header_name">
                <p>考核情况</p>
                <div class="checkCondition_header_rangTime">
                    {{timeStart}} 至 {{timeEnd}}
                </div>
            </div>
            <div class="checkCondition_header_search" style="display:none">
                <div class="checkCondition_header_label">
                    派单时间
                </div>
                <el-date-picker
                    v-model="value1"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    :size="size"
                />
                <el-radio-group v-model="radio">
                    <el-radio-button label="1">总</el-radio-button>
                    <el-radio-button label="2">今</el-radio-button>
                    <el-radio-button label="3">周</el-radio-button>
                    <el-radio-button label="4">月</el-radio-button>
                </el-radio-group>
                <div class="checkCondition_header_searchBtn">
                    <i class="icon-file-excel"></i>
                    <span>导出Excel</span>
                </div>
            </div>
        </div>
        <div class="checkCondition_table">
            <el-table :data="tableData">
                <el-table-column prop="name" label="承办部门" min-width="16%"/>
                <el-table-column sortable prop="gdzl" label="工单总量" min-width="12%"/>
                <el-table-column sortable prop="bjl" label="办结率" min-width="12%"/>
                <el-table-column sortable prop="csl" label="超时率" min-width="12%"/>
                <el-table-column sortable prop="thbhl" label="退回驳回率" min-width="12%">
                </el-table-column>
                <el-table-column sortable prop="zhpf" label="综合评分" min-width="12%">
                </el-table-column>
                <el-table-column sortable prop="sort" align="center" label="排名" min-width="12%">
                    <template #default="scope">
                        <div class="home_table_rank rankFirst" v-show="scope.row.sort == 1">
                            1
                        </div>
                        <div class="home_table_rank rankSecond" v-show="scope.row.sort ==2">
                            2
                        </div>
                        <div class="home_table_rank rankThird" v-show="scope.row.sort ==3">
                            3
                        </div>
                        <div class="home_table_rank" v-show ="scope.row.sort>3">
                            {{scope.row.sort}}
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!--<div class="checkCondition_table_page">-->
                <!--<el-pagination-->
                    <!--:page-sizes="[20, 30, 40, 50]"-->
                    <!--layout=" sizes, prev, pager, next, jumper"-->
                    <!--:total="totalNum"-->
                    <!--@size-change="handleSizeChange"-->
                    <!--:page-size="currentSize"-->
                    <!--@current-change="handleCurrentChange"-->
                <!--/>-->
            <!--</div>-->
        </div>
    </div>
</template>

<script>
    import {reactive, ref, watch, onMounted, getCurrentInstance} from 'vue'
    export default {
        name: "CheckCondition",
        setup() {
            const {proxy} = getCurrentInstance();
            const tableData = ref([]);
            let timeEnd = ref();
            let timeStart = ref();
            onMounted(()=>{
                proxy.$axios.post("/jgfast/datawayapi/wgsjtj/khqk").then((res) => {
                    tableData.value = res.value.data;
                    timeEnd.value = res.value.timeEnd;
                    timeStart.value = res.value.timeStart;
                })
            })
            const totalNum = ref(200)
            return {
                timeStart,
                timeEnd,
                tableData,
                totalNum
            }
        }
    }
</script>

<style scoped>

</style>
